// The screen after the request is sent (src/main.ts): what it may show of the
// address, and which inbox it may offer to open. Pure, so it is tested alone.

/** The address as the page shows it once sent: enough to recognise a typo,
 *  never an address - the page promises Google's tag sees none on it. */
export function maskEmail(email: string): string {
  const at = email.lastIndexOf('@');
  if (at < 1) return '•••';
  const local = email.slice(0, at);
  return `${local.slice(0, local.length > 2 ? 2 : 1)}•••${email.slice(at)}`;
}

/** The mail providers the page knows, by the address's domain: a name and where
 *  its inbox opens - Gmail already searching every folder for our letters. */
const MAILERS: { domains: string[]; name: string; href: string }[] = [
  { domains: ['gmail.com', 'googlemail.com'], name: 'Gmail', href: 'https://mail.google.com/mail/u/0/#search/from%3Aedtechcore.com+in%3Aanywhere' },
  { domains: ['outlook.com', 'hotmail.com', 'live.com', 'msn.com'], name: 'Outlook', href: 'https://outlook.live.com/mail/0/' },
  { domains: ['ukr.net'], name: 'ukr.net', href: 'https://mail.ukr.net/' },
  { domains: ['i.ua'], name: 'I.UA', href: 'https://mail.i.ua/' },
  { domains: ['wp.pl'], name: 'WP Poczta', href: 'https://poczta.wp.pl/' },
  { domains: ['o2.pl'], name: 'Poczta o2', href: 'https://poczta.o2.pl/' },
  { domains: ['onet.pl', 'op.pl', 'onet.eu'], name: 'Onet Poczta', href: 'https://poczta.onet.pl/' },
  { domains: ['interia.pl', 'interia.eu'], name: 'Interia Poczta', href: 'https://poczta.interia.pl/' },
];

/** The provider whose inbox the address lives in, or null for one the page does not know. */
export function mailerFor(email: string): { name: string; href: string } | null {
  const domain = email.slice(email.lastIndexOf('@') + 1).toLowerCase();
  const known = MAILERS.find((m) => m.domains.includes(domain));
  return known ? { name: known.name, href: known.href } : null;
}
